// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u1MZkm3YoYw2TQ7fJUIj{border-radius:16px;width:500px;padding:16px 1px 16px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageField": `u1MZkm3YoYw2TQ7fJUIj`
};
export default ___CSS_LOADER_EXPORT___;
